import styled from 'styled-components';

import {
  ripeLemon,
  cloudBurst,
  portage0,
  portage20,
} from '@paradigm/design-system/src/colors';

import { useRfqBuilderView } from '@paradigm/features/src/unified-rfqs/ui';

import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

const Container = styled.div`
  background-color: ${cloudBurst};
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 14px;
  border-radius: 3px;
`;

const Divider = styled.div`
  background: linear-gradient(to right, ${portage0}, ${portage20}, ${portage0});
  height: 2px;
  width: 100%;
`;

const YellowDot = styled.div`
  background-color: ${ripeLemon};
  border-radius: 50%;
  height: 4px;
  width: 4px;
  position: relative;
  top: 2px;
  left: 4px;
`;

const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 16px;
`;

const TitleText = styled.div`
  display: flex;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 1rem;
  }
`;

const SmallText = styled.div`
  color: #ffffff;
  opacity: 0.5;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 0.875rem;
  }
`;

const ValueText = styled.div`
  color: #ffffff;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 0.875rem;
  }
`;

const Note = styled.div`
  font-size: 0.75rem;
  padding: 0.5rem 0;
  color: ${ripeLemon};
  line-height: 1rem;
  &::before {
    content: '\u2022';
    color: ${ripeLemon};
    margin-right: 3px;
  }
`;

export default function StrategyOptionGreeks() {
  const { greeks } = useRfqBuilderView();

  return (
    <div>
      <Container>
        <ContainerRow>
          <TitleText>
            Strategy Option Greeks (Unhedged)
            {greeks.isShowingGreeks === true && <YellowDot />}
          </TitleText>
        </ContainerRow>
        <ContainerRow>
          <SmallText>Delta (∆)</SmallText>
          <ValueText data-testid="strategy-option-greeks-delta">
            {greeks.delta}
          </ValueText>
        </ContainerRow>
        <ContainerRow>
          <SmallText>Gamma (Γ)</SmallText>
          <ValueText data-testid="strategy-option-greeks-gamma">
            {greeks.gamma}
          </ValueText>
        </ContainerRow>
        <ContainerRow>
          <SmallText>Vega (V)</SmallText>
          <ValueText data-testid="strategy-option-greeks-vega">
            {greeks.vega}
          </ValueText>
        </ContainerRow>
        <ContainerRow>
          <SmallText>Theta (Θ)</SmallText>
          <ValueText data-testid="strategy-option-greeks-theta">
            {greeks.theta}
          </ValueText>
        </ContainerRow>
        <Divider />
        <ContainerRow>
          <SmallText>Mark</SmallText>
          <ValueText data-testid="strategy-option-greeks-mark-price">
            {greeks.mark_price}
          </ValueText>
        </ContainerRow>
      </Container>
      {greeks.isShowingGreeks === true && (
        <Note>Above Greek values are static for reference</Note>
      )}
    </div>
  );
}
